import { useLazyQuery, useQuery } from '@apollo/client';
import { Form, Button, Select, Row, Col, Collapse, DatePicker } from 'antd';
import { endOfDay, getTime, startOfDay, format, subDays } from 'date-fns';
import moment from 'moment';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { subMonths } from 'date-fns';
import useNotification from '../../hooks/layout/useNotification';
import { formatToTimeZone, getStartOfDayInTimeZone, getEndOfDayInTimeZone } from '../../shared/helpers/date-format.helper';
import { GET_BANK_DD_BY_MERCHANT_WALLET } from '../banks/Bank.gql';

interface Props {
    setFilters: Dispatch<SetStateAction<{ bankId: string, currencyId: string, startDate: string, endDate: string }>>;
    filters: { bankId: string, currencyId: string, startDate: string, endDate: string };
}

const DashboardFilter = ({ setFilters, filters }: Props) => {
    const [queryForm] = Form.useForm();
    const intl = useIntl();
    const formCol: any = { xs: 24, sm: 24, md: 8, lg: 6, xl: 6 };
    const { RangePicker } = DatePicker;

    const onFinish = (fieldsValue: any) => {
        emitFilter(fieldsValue.currencyId, fieldsValue.bankId, fieldsValue.datePicker);
    }

    const emitFilter = (currencyId: string, bankId: string, datePicker: any[]) => {
        const startDateRaw = datePicker && datePicker.length > 0 ? new Date(datePicker[0]) : subDays(new Date(), 7);
        const endDateRaw = datePicker && datePicker.length > 0 ? new Date(datePicker[1]) : new Date();
        const startDate = formatToTimeZone(getStartOfDayInTimeZone(startDateRaw), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
        const endDate = formatToTimeZone(getEndOfDayInTimeZone(endDateRaw), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");

        setFilters({
            bankId: bankId ?? '',
            currencyId: currencyId ?? '',
            startDate, endDate
        });
    }

    return <Form layout="vertical"
        form={queryForm}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{ ...filters, datePicker: filters.startDate && filters.endDate ? [moment(filters.startDate.split('T')[0]), moment(filters.endDate.split('T')[0])] : undefined }}
        className="filter-panel">
        <Row gutter={[8, 4]}>
            <Col {...formCol}>
                <Form.Item label={intl.formatMessage({ id: 'CREATED_DATE' })} name="datePicker" >
                    <RangePicker style={{ width: '100%' }} />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item className="filter-button-group">
                    <Button type="primary" htmlType="submit"><FormattedMessage id='SEARCH' /></Button>
                </Form.Item>
            </Col>
        </Row>
    </Form>
        ;
}

export default DashboardFilter;